export enum VesselParticulars {
  imo = "IMO",
  sign = "Call Sign",
  gross = "Gross Tonnage",
  flag = "Flag",
  len = "Registered Length",
  mmsi = "MMSI",
  num = "Official Num",
  net = "Net Tonnage",
  port = "Port of registry",
}

export enum VesselEntries {
  lastActiveDate = "Last Active Date/Time",
  lastActiveUser = "Last Active User",
  lastEntryDate = "Last Entry Date/Time",
  lastEntryTitle = "Last Entry Title",
  lastEntryUser = "Last Entry User",
  numberOfOpenEntries = "Number of Open Entries",
  requiredVerifier = "Required Verifier",
  requiredCoSigner = "Required Co-Signer",
}

export enum VesselSubscriptions {
  datecreated = "Date Vessel Was Added",
  subscriptionStartDate = "Subscription Start Date",
  bot = "Bolt Ons Taken",
  dateArchived = "Date Vessel Was Archived",
  activeCrew = "Active Crew",
  inactiveCrew = "Inactive Crew",
  archivedCrew = "Archived Crew",
}

export enum VesselReviews {
  lastReview = "Last Review",
  lastReviewer = "Last Reviewer",
}

export enum VesselAudits {
  lastAuditDate = "Last Audit Date",
  lastAuditor = "Last Auditor",
}
